<template>
  <div :id="elementId" class="po-maps"></div>
</template>

<script>

import _ from 'lodash'
import mapBox from '@/mixins/map-box'

import { Geo, MapMarker } from '@/components/geography/util'

export default {
  name: 'PoMaps',
  mixins: [mapBox],
  props: {
    center: Object,
    centerLabel: String,
    centerMessage: String,
    zoom: { type: Number, default: 11 },
    movable: Boolean
  },
  data () {
    return {
      map: undefined,
      marker: undefined
    }
  },
  watch: {
    center (newValue, old) {
      if (!_.isEqual(newValue, old)) {
        this.updateCenter()
      }
    },
    movable () {
      this.updateMovable()
    }
  },
  methods: {
    onReady () {
      this.updateCenter()
    },
    updateCenter () {
      const map = this.ensureMap()
      if (map) {
        this.marker && this.marker.remove()
        this.marker = undefined

        if (this.center) {
          const lngLat = Geo.toLngLat(this.center)
          map.easeTo({ center: lngLat })

          if (this.centerLabel) {
            this.marker = new this.mapBox.Marker(MapMarker.options())
              .setLngLat(lngLat)
            const popup = new this.mapBox.Popup(MapMarker.popupOptions())
              .setHTML(MapMarker.popupHTML(this.centerLabel, this.centerMessage))

            this.marker.setPopup(popup)
            this.marker.on('dragend', this.emitMove)
            this.marker.addTo(map)
          }
        }

        this.updateMovable()
      }
    },
    updateMovable () {
      if (this.marker) {
        this.marker.setDraggable(this.movable)
        MapMarker.setPopupState(this.marker, !this.movable)
      }
    },
    emitMove () {
      this.$emit('move', Geo.fromLngLat(this.marker.getLngLat()))
    },
    ensureMap () {
      if (this.mapBox && !this.map && this.center) {
        const map = this.createMap({ center: Geo.toLngLat(this.center), zoom: this.zoom })
        map.addControl(new this.mapBox.NavigationControl())
        map.on('load', this.updateCenter)
      }
      return this.map
    }
  }
}
</script>
<style lang="scss">

$card-map-shadow-color: #cccccc;
$card-map-shadow-size: 8px;

.po-maps {
  min-height: 300px;
  position: relative;
}

.wo-card__content .po-maps {
  &:before, &:after {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    content: '';
    min-height: 10px;
  }
  &:before {
    top: 0;
    box-shadow: inset 0px ($card-map-shadow-size + 1) 8px (-$card-map-shadow-size) $card-map-shadow-color;
  }
  &:after {
    bottom: 0;
    box-shadow: inset 0px (-$card-map-shadow-size - 1) 8px (-$card-map-shadow-size) $card-map-shadow-color;
  }
}
</style>
